/* ==========================================================================
   Tooltip > Client > Prototype
   ========================================================================== */

/* Import modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { initPopper, destroyPopper } = require('./popper');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        this.store = new Store({
            data: reducer
        });

        return this;
    },
    /* Setup actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy())
        };

        return this;
    },
    /* Setup reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Popper */
                destroyPopper(this);

                /* Unsubscribe */
                [...Object.keys(this.reactions)].forEach(key => this.reactions[key].unsubscribe());

                /* Clean DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean reference */
                [...Object.keys(this)].forEach(key => delete this[key]);
            })
        };

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Popper */
        initPopper(this);

        return this;
    }
};

/* Exports */
module.exports = prototype;
